// Size chart drawer - Handles the drawer open/close events
if (!customElements.get("size-chart-drawer")) {
  customElements.define(
    "size-chart-drawer",
    class extends HTMLElement {
      constructor() {
        super();

        this.drawerOverlay = this.querySelector(".size-chart-drawer-overlay");
        this.drawerClose = this.querySelector(".size-chart-drawer-close");
      }

      connectedCallback() {
        this.addEventListener(
          "keyup",
          (evt) => evt.code === "Escape" && this.close()
        );

        if (this.drawerOverlay)
          this.drawerOverlay.addEventListener("click", this.close.bind(this));

        if (this.drawerClose)
          this.drawerClose.addEventListener("click", this.close.bind(this));

        this.setTriggerLinkAccessibility();

        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          this.setTriggerLinkAccessibility();
        })
      }

      setTriggerLinkAccessibility() {
        const sizeChartTrigger = document.querySelector(
          ".size-chart-drawer-trigger"
        );
        sizeChartTrigger.setAttribute("role", "button");
        sizeChartTrigger.setAttribute("aria-haspopup", "dialog");
        sizeChartTrigger.addEventListener("click", (event) => {
          event.preventDefault();
          this.open(sizeChartTrigger);
        });
        sizeChartTrigger.addEventListener("keydown", (event) => {
          if (event.code.toUpperCase() === "SPACE") {
            event.preventDefault();
            this.open(sizeChartTrigger);
          }
        });
      }

      open(triggeredBy) {
        if (triggeredBy) this.setActiveElement(triggeredBy);
        setTimeout(() => {
          this.classList.add("animate", "active");
        });

        this.addEventListener(
          "transitionend",
          () => {
            const containerToTrapFocusOn =
              document.getElementById("SizeChartDrawer");
            const focusElement =
              this.querySelector(".size-chart-drawer-inner") ||
              this.querySelector(".size-chart-drawer-close");

            trapFocus(containerToTrapFocusOn, focusElement);
          },
          { once: true }
        );

        document.body.classList.add("overflow-hidden");
      }

      close() {
        this.classList.remove("active");
        removeTrapFocus(this.activeElement);
        document.body.classList.remove("overflow-hidden");
      }

      setActiveElement(element) {
        this.activeElement = element;
      }
    }
  );
}